// extracted by mini-css-extract-plugin
export default {"mobileHeader":"gRWwbOksWlZNERLY0nXt","mobileTitle":"mnGzdwYDJSrm4F2fmfqt","verticalDivider":"AT5QmKmWcVjNfQ2CyAwz","icon":"B_zwns1X7KhDDLKsKXsy"};